module.exports = __webpack_public_path__ + "static/media/108c3.5eb3334b.jpg";